import { render, staticRenderFns } from "./delete-follow-record.vue?vue&type=template&id=8500038e&scoped=true"
import script from "./delete-follow-record.vue?vue&type=script&lang=ts"
export * from "./delete-follow-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8500038e",
  null
  
)

export default component.exports